import React from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text, Flex } from "@similarweb/ui-components/foundations";

import { NumberFormatter } from "app/pages/digital-marketing/monitor-and-protect/services/number-formatter";
import { TruncateText } from "app/pages/digital-marketing/monitor-and-protect/shared/ui/typography/texts";

type ChartCompetitor = {
    name: string;
    color: string;
    totalClicks: number;
    share: number;
};

interface ICompetitorChartTooltipProps {
    competitors: Array<ChartCompetitor>;
    period: string;
}

const TooltipContainer = styled.div`
    background: #ffffff;
    border-radius: 3px;
`;

const TableGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr auto auto;
    gap: 6px 16px;
    margin-top: 12px;
`;

const DomainCell = styled(Flex)`
    gap: 8px;
`;

const ColorDot = styled.div<{ color: string }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${(props) => props.color};
    flex-shrink: 0;
`;

export const CompetitorsChartTooltip = ({ period, competitors }: ICompetitorChartTooltipProps) => {
    return (
        <TooltipContainer>
            <Stack>
                <Text
                    fontVariant={"subtitle1"}
                    color={colorsPalettes.carbon["500"]}
                >
                    {period}
                </Text>

                <TableGrid>
                    <Text
                        fontVariant="listItem3"
                        color={colorsPalettes.carbon["400"]}
                    >
                        Domain
                    </Text>
                    <Text
                        fontVariant="listItem3"
                        color={colorsPalettes.carbon["400"]}
                        style={{ textAlign: "right" }}
                    >
                        Total Clicks
                    </Text>
                    <Text
                        fontVariant="listItem3"
                        color={colorsPalettes.carbon["400"]}
                        style={{ textAlign: "right" }}
                    >
                        Share
                    </Text>

                    {competitors.map((competitor, index) => (
                        <React.Fragment key={index}>
                            <DomainCell alignItems="center">
                                <ColorDot color={competitor.color} />
                                <TruncateText
                                    maxWidth="180px"
                                    fontVariant="body2"
                                    color={colorsPalettes.carbon["500"]}
                                    lineClamp={1}
                                >
                                    {competitor.name}
                                </TruncateText>
                            </DomainCell>
                            <Text
                                fontVariant="body2"
                                display="flex"
                                justifyContent="flex-end"
                                color={colorsPalettes.carbon["500"]}
                            >
                                {NumberFormatter.toAbbr(competitor.totalClicks, 0, "—")}
                            </Text>
                            <Text
                                fontVariant="body2"
                                display="flex"
                                justifyContent="flex-end"
                                color={colorsPalettes.carbon["300"]}
                            >
                                {NumberFormatter.toPercent(competitor.share, 0, "—")}
                            </Text>
                        </React.Fragment>
                    ))}
                </TableGrid>
            </Stack>
        </TooltipContainer>
    );
};
